exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-doc-page-js": () => import("./../../../src/templates/doc-page.js" /* webpackChunkName: "component---src-templates-doc-page-js" */)
}

